export default __webpack_public_path__ + "static/media/acryl-light-mark.7c15c8a4.svg";